import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Baseurl } from "../../config/BaseUrl";

const getCachedData = (key) => {
  try {
    if (typeof window !== "undefined") {
      const local = localStorage.getItem(key);
      if (local) return JSON.parse(local);
      const session = sessionStorage.getItem(key);
      if (session) return JSON.parse(session);
    }
    return [];
  } catch (e) {
    return [];
  }
};

const initialState = {
  catTotal: getCachedData("cached_catTotal"),
  catLoading: false,
  categoryLoading: false,
  appliedFilters: [],
};

export const getCategory = createAsyncThunk(
  "Category/getCategory",
  async (thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/category/all`;
      const resp = await axios(url);
      return resp.data.category;
    } catch (error) {
      return thunkAPI.rejectWithValue("Category Not Found");
    }
  }
);

const CategorySlice = createSlice({
  name: "Category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategory.pending, (state) => {
        state.catLoading = true;
      })
      .addCase(getCategory.fulfilled, (state, action) => {
        state.catLoading = false;
        state.categoryLoading = false;
        state.catTotal = action.payload || [];
        try {
          if (typeof window !== "undefined") {
            localStorage.setItem("cached_catTotal", JSON.stringify(action.payload));
            sessionStorage.setItem("cached_catTotal", JSON.stringify(action.payload));
          }
        } catch (e) {}
      })
      .addCase(getCategory.rejected, (state) => {
        state.catLoading = false;
      });
  },
});

export const categoryActions = CategorySlice.actions;
export default CategorySlice.reducer;
